
import {
    X,
    Edit3,
    CheckCircle,
    MessageSquareMore,
    User,
    Tag,
    Shield,
    BadgeCheck,
    Database,
} from "lucide-react";

export default function AddTermModal({ onClose, onSubmit }) {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const newTerm = {
            term: formData.get('term'),
            status: formData.get('status'),
            department: formData.get('department'),
            definition: formData.get('definition'),
            formula: formData.get('formula'),
            owner: formData.get('owner'),
            classification: formData.get('classification'),
            certificate: formData.get('certificate'),
            businessContext: formData.get('businessContext'),
            dataType: formData.get('dataType'),
            source: formData.get('source'),
            tags: formData.get('tags').split(',').map(tag => tag.trim()),
        };
        onSubmit(newTerm);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="w-full max-w-5xl rounded-lg bg-white shadow-xl">
                <div className="flex min-h-[520px]">
                    {/* LEFT PANEL */}
                    <div className="flex-1 border-r p-3">
                        <form onSubmit={handleSubmit} id="addTermForm">
                            {/* Header */}
                            <div className="flex items-start justify-between">
                                <div>
                                    <div className="flex items-center gap-[3px]">
                                        <input
                                            type="text"
                                            name="term"
                                            required
                                            className="text-lg font-semibold border-none outline-none focus:ring-0 p-0 bg-transparent"
                                            placeholder="Enter term name"
                                        />
                                    </div>
                                    <div className="text-xs text-black mt-[10px] flex items-center">
                                        <span className="border border-gray-300 px-[4px] py-[4px] rounded-full mr-[4px]">TERM</span>
                                        <span className="mr-[4px]">•</span>
                                        <input
                                            type="text"
                                            name="department"
                                            required
                                            className="border-none outline-none focus:ring-0 p-0 bg-transparent text-xs"
                                            placeholder="department name"
                                        />
                                    </div>
                                </div>


                            </div>

                            {/* Tabs */}
                            <div className="mt-4 flex gap-6 border-b text-sm">
                                <button
                                    type="button"
                                    className="border-b-2 border-blue-600 pb-2 font-medium"
                                >
                                    Overview
                                </button>
                                <button type="button" className="pb-2 text-gray-500">
                                    Feedback (0)
                                </button>
                            </div>

                            {/* Definition */}
                            <div className="mt-4">
                                <p className="text-sm font-medium">Definition</p>
                                <textarea
                                    name="definition"
                                    required
                                    rows="3"
                                    className="mt-1 w-full text-sm text-gray-700 border border-gray-300 rounded-md px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                    placeholder="Enter a clear and concise definition..."
                                />
                            </div>

                            {/* Formula */}
                            <div className="mt-4">
                                <div className="mt-2 rounded bg-[#A3A2A9] p-3">
                                    <p className="text-sm font-medium text-black mb-[6px]">Formula</p>
                                    <input
                                        type="text"
                                        name="formula"
                                        className="w-full bg-transparent border-none outline-none font-mono text-sm text-[#7C3AED] placeholder-[#7C3AED]"
                                        placeholder="e.g., Bias = Σ(Forecast − Actual) / n"
                                    />
                                </div>
                            </div>

                            {/* Business Context */}
                            <div className="mt-4">
                                <p className="text-sm font-medium">Business Context</p>
                                <textarea
                                    name="businessContext"
                                    rows="2"
                                    className="mt-1 w-full text-sm text-gray-700 border border-gray-300 rounded-md px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                    placeholder="Explain how this term is used in business operations..."
                                />
                            </div>

                            {/* Data Type & Source */}
                            <div className="mt-4 flex gap-10 text-sm text-gray-600">
                                <div className="flex gap-[4px] items-center justify-center">
                                    <Database size={14} />
                                    <span>Data Type:</span>
                                    <input
                                        type="text"
                                        name="dataType"
                                        className=" border border-gray-300 px-3 py-2  text-gray-600 w-32"
                                        placeholder="Number"
                                    />
                                </div>
                                <div className="flex gap-[4px] items-center justify-center">
                                    <Database size={14} />
                                    <span>Source:</span>
                                    <input
                                        type="text"
                                        name="source"
                                        className=" border border-gray-300 px-3 py-2   text-gray-600 w-32"
                                        placeholder="SAP IBP"
                                    />
                                </div>
                            </div>

                            {/* Tags */}
                            <div className="mt-4">
                                <p className="text-sm font-medium flex gap-[4px] items-center">
                                    <Tag size={12} />
                                    Tags
                                </p>
                                <div className="mt-2">
                                    <input
                                        type="text"
                                        name="tags"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                        placeholder="Enter tags separated by commas (e.g., Forecast, Quality, Statistics)"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        Separate multiple tags with commas
                                    </p>
                                </div>
                            </div>

                            {/* Footer Actions */}
                            {/* <div className="mt-6 flex gap-3 justify-end">
                                <button
                                    type="button"
                                    className="flex items-center gap-1 text-black rounded border px-3 py-1 text-sm opacity-50 cursor-not-allowed"
                                    disabled
                                >
                                    <MessageSquareMore size={10} /> Comment
                                </button>
                                <button
                                    type="button"
                                    className="flex items-center gap-1 text-black rounded border px-3 py-1 text-sm opacity-50 cursor-not-allowed"
                                    disabled
                                >
                                    <MessageSquareMore size={10} /> Report Issue
                                </button>
                            </div> */}
                        </form>
                    </div>

                    {/* RIGHT PANEL */}
                    <div className="relative w-80 bg-[#e3dede] p-3">
                        <X
                            onClick={onClose}
                            className="absolute right-1 top-4 h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700"
                        />

                        <form id="rightPanelForm" onSubmit={handleSubmit}>
                            {/* Owner */}
                            <p className="text-xs font-semibold mb-[5px] text-black">OWNERS</p>
                            <div className="mb-3 flex items-center text-sm gap-1">
                                <User className="h-4 text-gray-500" />
                                <input
                                    type="text"
                                    name="owner"
                                    required
                                    className="flex-1 border border-gray-300 rounded px-2 py-1 outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
                                    placeholder="Owner name"
                                />
                            </div>

                            {/* Classification */}
                            <p className="mb-3 text-xs font-semibold text-black">
                                CLASSIFICATION
                            </p>
                            <div className="mb-4 flex gap-[10px] items-center">
                                <Shield size={10} />
                                <input
                                    type="text"
                                    name="classification"
                                    required
                                    className="flex-1 border border-gray-300 rounded px-2 py-1 outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
                                    placeholder="Internal"
                                />
                            </div>

                            {/* Certificate */}
                            <p className="mb-3 text-xs font-semibold text-black">
                                CERTIFICATE
                            </p>
                            <div className="mb-1 flex items-center text-sm gap-1">
                                <BadgeCheck className="h-4 text-green-600" />
                                <input
                                    type="text"
                                    name="certificate"
                                    className="flex-1 border border-gray-300 rounded px-2 py-1 outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
                                    placeholder="Verified"
                                />
                            </div>


                            {/* Status */}
                            <p className="mb-3 text-xs font-semibold text-black mt-4">STATUS</p>
                            <input
                                type="text"
                                name="status"
                                required
                                className="mb-4 inline-block rounded px-2 py-1 text-xs text-black bg-white border border-gray-300 outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-auto"
                                placeholder="Approved"
                            />

                            {/* Department (hidden, already in left panel) */}
                            <input type="hidden" name="department" />

                            {/* Last Updated */}
                            <p className="mt-4 mb-2 text-xs font-semibold text-black">
                                LAST UPDATED
                            </p>
                            <input
                                type="date"
                                name="lastUpdated"
                                className="mb-6 text-sm border border-gray-300 rounded px-2 py-1 bg-white outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-full"
                                defaultValue={new Date().toISOString().split('T')[0]}
                            />

                            {/* Quality Score */}
                            <p className="mb-3 text-xs font-semibold text-black">
                                QUALITY SCORE
                            </p>
                            <div className="h-2 w-full rounded bg-gray-200">
                                <div
                                    className="h-2 rounded bg-green-600"
                                    style={{ width: '0%' }}
                                />
                            </div>
                            <p className="mt-1 text-xs">0%</p>

                            {/* Action Buttons */}
                            <div className="mt-6 flex gap-2">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm hover:bg-gray-50"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    form="addTermForm"
                                    className="flex-1 px-3 py-2 bg-[#bb1ccc] text-white rounded text-sm hover:bg-blue-700"
                                >
                                    Add Term
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
